import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type FeatureFlagsService from 'garaje/services/feature-flags';

export default class LocationOverviewAiWatchlistRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare router: RouterService;

  titleToken = 'AI Watchlist';

  beforeModel(): void {
    if (!this.featureFlags.isEnabled('ai-watchlist') || this.abilities.cannot('visit ai-watchlist')) {
      void this.router.transitionTo('unauthorized');
    }
  }
}
